<footer class="app-footer">
  <span>&copy; {{ year }} MAQI</span>
</footer>
